import './LeitorQr.css'
import React, { useState, useEffect, useRef } from "react";
import LeitorQr from './LeitorQr'

const LeitorQrWrapper = ({ token, putLeituraQr, putModalLeitura, putCameramode, cameraMode, statusLeitura}) => {

    const handleLeituraQr = (leituraText) => {
        putLeituraQr(leituraText);
    }

    const handleCameraMode = (cameraModeLeitura) => {
        putCameramode(cameraModeLeitura);
    }

    const handleModalLeitura = () => {
        putModalLeitura();
    }

    return (
        <div class="wrapper">
            {statusLeitura &&
                <LeitorQr cameraMode={cameraMode} putLeituraQr={handleLeituraQr} putCameramode={handleCameraMode} putModalLeitura={handleModalLeitura} />}
        </div>
    );
}

export default LeitorQrWrapper